<script>
import IconFormGuide from './assets/IconFormGuide';
import IconRacingResult from './assets/IconRacingResult';
import IconRacingNews from './assets/IconRacingNews';
import IconBonusBets from './assets/IconBonusBets';
import IconMenu from './assets/IconMenu';
import IconClose from './assets/IconClose';
import { setCookie, getCookie } from '../../plugins/cookies';

export default {
  name: 'BottomMenu',
  components: {
    IconFormGuide,
    IconRacingResult,
    IconRacingNews,
    IconBonusBets,
    IconMenu,
    IconClose,
  },
  props: {
    pathName: {
      type: String,
      default: '',
    },
  },
  data: () => {
    return {
      isMenuOpen: false,
      isBonusBetsClicked: false,
    };
  },
  computed: {
    menuBtnId() {
      return this.isMenuOpen ? `nav-close-btn` : `nav-open-btn`;
    },
    bonusBetBtnClass() {
      let result = `bottom-menu__item bottom-menu__item--offers `;
      if (!this.isBonusBetsClicked) {
        result = `${result} offer-with-number-icon`;
      }
      return result;
    },
  },
  beforeMount() {
    this.isBonusBetsClicked = getCookie('bonusBetsClickedV1');
  },
  methods: {
    handleToggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      this.$emit('handleToggleMenu', this.isMenuOpen);
    },
    handleClickBonusBets() {
      if (!this.isBonusBetsClicked) {
        this.isBonusBetsClicked = true;
        const ONE_DAY = 86500;
        setCookie({ name: 'bonusBetsClickedV1', value: true, secure: false, duration: ONE_DAY });
      }
    },
  },
};
</script>

<template>
  <nav :class="`bottom-menu-wrap--${pathName} bottom-menu-wrap`">
    <ul class="bottom-menu__item-wrap">
      <li class="bottom-menu__item">
        <a href="/form-guide/" class="bottom-menu__item-inner">
          <IconFormGuide />
          <span>Form</span>
        </a>
      </li>
      <li class="bottom-menu__item">
        <a href="/racing-results/" class="bottom-menu__item-inner">
          <IconRacingResult />
          <span>Results</span>
        </a>
      </li>
      <li :class="bonusBetBtnClass" @click="handleClickBonusBets">
        <a href="/betting/bonus-bets/" class="bottom-menu__item-inner">
          <IconBonusBets />
          <span>Offers</span>
        </a>
      </li>
      <li class="bottom-menu__item">
        <a href="/news/" class="bottom-menu__item-inner">
          <IconRacingNews />
          <span>News</span>
        </a>
      </li>
      <li :id="menuBtnId" class="bottom-menu__item">
        <button
          :class="[{'nav-open-btn--open':isMenuOpen}, 'bottom-menu__nav-open-btn', 'bottom-menu__item-inner']"
          @click.prevent="handleToggleMenu"
        >
          <IconMenu v-if="!isMenuOpen" />
          <IconClose v-if="isMenuOpen" />
          <span>Menu</span>
        </button>
      </li>
    </ul>
  </nav>
</template>
